// extracted by mini-css-extract-plugin
module.exports = {"splitter":"Splitter_splitter__eO1XX","isDragging":"Splitter_isDragging__1nwNW","scrim":"Splitter_scrim__2BCtv"};